import axios from 'axios'
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

export default function () {
	const Home = document.querySelector('#single-location-content')
	if (!Home) return
	console.log('Page Single Location')

	const swiperTabsCalendar = new Swiper('.swiper-tabs-calendar', {
		slidesPerView: 'auto',
		spaceBetween: 16,
		navigation: { nextEl: '.swiper-button-tabs-calendar-next', prevEl: '.swiper-button-tabs-calendar-prev' },
		breakpoints: { 1024: { spaceBetween: 32 } },
	})

	const swiperSingleAcademy = new Swiper('.swiper-single-academy', {
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 20,
		loop: true,
		navigation: { nextEl: '.swiper-button-single-next', prevEl: '.swiper-button-single-prev' },
		breakpoints: { 600: { spaceBetween: 32 } },
		on: {
			slideChange: function () {
				const activeSlide = this.slides[this.activeIndex]
				const allSlides = document.querySelectorAll('.swiper-single-academy .swiper-slide .bg-slides-gray')
				allSlides.forEach((i) => i.classList.add('activate'))
				const bg = activeSlide?.querySelector('.bg-slides-gray')
				bg?.classList.remove('activate')
			},
		},
	})

	function updateSlideCounter(swiperInstance) {
		const current = swiperInstance.realIndex + 1
		const total = swiperInstance.slides.length - (swiperInstance.loopedSlides * 2 || 0) || swiperInstance.slides.length
		const el = document.getElementById('slide-counter')
		if (el) el.innerHTML = `<span class='text-white'>${current}</span><span class='text-white/40'>/${total}</span>`
	}

	function markActiveInstructor(swiper) {
		swiper.slides.forEach((slide) => slide.classList.remove('is-active'))
		const active = swiper.slides[swiper.activeIndex]
		if (active) active.classList.add('is-active')
	}

	const swiperSingleInstrutores = new Swiper('.swiper-single-instrutores', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		centeredSlides: true,
		navigation: { nextEl: '.swiper-button-instrutores-single-next', prevEl: '.swiper-button-instrutores-single-prev' },
		breakpoints: { 0: { spaceBetween: 12 }, 1024: { spaceBetween: 0 } },
		on: {
			init() {
				updateSlideCounter(this)
				markActiveInstructor(this)
			},
			slideChange() {
				updateSlideCounter(this)
				markActiveInstructor(this)
			},
		},
	})

	const contatoFormSubmit = document.querySelector('#formulario_contact')
	const contatoFormSubmitClass = document.querySelector('#formulario_contact_class')

	contatoFormSubmit &&
		contatoFormSubmit.addEventListener('submit', function (event) {
			event.preventDefault()
			disabledBtn(contatoFormSubmit)

			const formData = {
				nome: document.querySelector('#formulario_contact input[name=nome]').value,
				email: document.querySelector('#formulario_contact input[name=email]').value,
				mensagem: document.querySelector('#formulario_contact textarea[name=mensagem]').value,
			}

			console.log(formData)

			const url = '/fale-conosco/'
			axios
				.post(url, formData, {
					headers: {
						'Content-Type': 'application/json',
						'X-CSRFToken': getCookie('csrftoken'), // CSRF Token necessário no Django
					},
				})
				.then((response) => {
					showMessage(response)
				})
				.catch((error) => showMessage(error.response || error))
		})

	contatoFormSubmitClass &&
		contatoFormSubmitClass.addEventListener('submit', function (event) {
			event.preventDefault()
			disabledBtn(contatoFormSubmitClass)

			const formData = {
				nome: document.querySelector('#formulario_contact_class input[name=nome]').value,
				email: document.querySelector('#formulario_contact_class input[name=email]').value,
				mensagem: document.querySelector('#formulario_contact_class textarea[name=mensagem]').value,
			}

			console.log(formData)

			const url = '/form-inscricao/'
			axios
				.post(url, formData, {
					headers: {
						'Content-Type': 'application/json',
						'X-CSRFToken': getCookie('csrftoken'), // CSRF Token necessário no Django
					},
				})
				.then((response) => {
					showMessage(response)
				})
				.catch((error) => showMessage(error.response || error))
		})

	function showMessage(response) {
		const message = response.data ? response.data.message : 'Erro ao enviar a mensagem'
		Toastify({
			text: message,
			duration: 3000,
			newWindow: true,
			close: true,
			gravity: 'top',
			position: 'center',
			stopOnFocus: true,
			style: {
				background: 'linear-gradient(to right, #00b09b, #96c93d)',
			},
		}).showToast()

		contatoFormSubmit.reset()
		setTimeout(enabledBtn, 1000)
	}

	const btnSubmit = document.querySelector('#formulario_contact button[type=submit]')

	function disabledBtn(form) {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
	}

	// Função para obter o token CSRF do cookie
	function getCookie(name) {
		let cookieValue = null
		if (document.cookie && document.cookie !== '') {
			let cookies = document.cookie.split(';')
			for (let i = 0; i < cookies.length; i++) {
				let cookie = cookies[i].trim()
				if (cookie.startsWith(name + '=')) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
					break
				}
			}
		}
		return cookieValue
	}

	document.addEventListener('DOMContentLoaded', function () {
		const tabs = document.querySelectorAll('#single-location-content .tabs-calendar')

		function filter(nome) {
			document.querySelectorAll('#single-location-content .table-wrapper').forEach((wrapper) => {
				const items = wrapper.querySelectorAll('.table-content-horario li[data-nome]')
				const placeholder = wrapper.querySelector('.placeholder-vazio')
				let hasVisible = false
				items.forEach((li) => {
					if (li.dataset.nome === nome) {
						li.style.display = ''
						hasVisible = true
					} else {
						li.style.display = 'none'
					}
				})
				if (placeholder) placeholder.style.display = hasVisible ? 'none' : ''
			})
		}

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				tabs.forEach((t) => t.classList.remove('active'))
				tab.classList.add('active')
				filter(tab.dataset.filter)
			})
		})

		const first = tabs[0]
		if (first) filter(first.dataset.filter)
	})
}
